// @core/api/endpoints/document/create_document_template.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateDocumentTemplateRequest,
  DocumentTemplateResponse,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Create template
 * Creates a reusable document template with pre-filled structure and defaults.
 */
export async function CreateDocumentTemplate(
  data: CreateDocumentTemplateRequest,
  options?: RequestOptions
): Promise<DocumentTemplateResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/document-templates`;
  const requestOptions = options;
  return client.post<DocumentTemplateResponse>(requestPath, data, requestOptions);
}
